import "./Contacts.module.css";
import Header from "@/reusable_sections/Header";
import ContactForm from "./sections/ContactForm";
import Footer from "@/reusable_sections/Footer";
export default function ContactsPage() {
  return <div className="relative min-h-screen overflow-hidden">
      {}
      <iframe src="https://www.youtube.com/embed/cFnU-NliESA?autoplay=1&mute=1&loop=1&playlist=cFnU-NliESA&controls=0&showinfo=0&rel=0" className="absolute inset-0 w-full h-full object-cover pointer-events-none" frameBorder="0" allow="autoplay; fullscreen"></iframe>

      {}
      <div className="absolute inset-0 bg-black/50 hover:bg-black/40 transition-colors duration-300 pointer-events-none"></div>

      {}
      <div className="relative z-10">
        <Header />
        <ContactForm />
        <Footer />
      </div>
    </div>;
}